import { ArrayType, ParseTreeResult } from '@angular/compiler';
import { Component, ElementRef, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import {
	IGridOptions,
	IColumns,
	IExportExcel,
	ISearchPanel,
	IScroll,
	Toolbar,
	IColumnHiding,
	ICheckbox,
	IEditing,
	IColumnchooser,
	TiposdeDato,
	TiposdeFormato
} from 'app/interfaces';
import { CoalService } from 'app/services/coal.service';
import { AsignaBreadcrumb } from 'app/store/actions/permisos.actions';
import { AppState, selectOperacionState, selectUtilsState } from 'app/store/app.states';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import { BaseService } from 'app/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { environment } from 'environments/environment';
import { HttpClient, JsonpClientBackend } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { sparrowService } from 'app/services/sparrowService';
import { formatDate } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { MatDrawer } from '@angular/material/sidenav';
import { takeUntil } from 'rxjs/operators';
import { FuseCardComponent } from '@fuse/components/card';
import { map, startWith } from 'rxjs/operators';

import { CancelaCFDI4Component } from '../cancela-cfdi4/cancela-cfdi4.component';
import { SuccessFacturacionComponent } from '../success-facturacion/success-facturacion.component';
import { FacturaService } from './factura.service';
import { style } from '@angular/animations';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FileService } from 'app/services/file.service';

export interface DialogData {
	emails: string;
	cc: string;
	asunto: string;
	mensaje: string;
}

export interface paramBusqueda {
	tipoBusqueda?: Number;
	busqueda?: String;
	periodoAnio?: Number;
	periodoMes?: Number;
	RFC?: String;
	lugarExpedicionCP?: String;
	tipoFactura?: Number;
	EstatusFactura?: Number;
	formaPago?: String;
	folioInicio?: Number;
	folioFin?: Number;
	fechaInicio?: String;
	fechaFin?: String;
}

export interface State {
	flag: string;
	name: string;
	population: string;
}

interface IBotones {
	editar: any;
	pdf: any;
	xml: any;
	email: any;
	cancelar: any;
	eliminar: any;
	acuse: any;
	duplicar: any;
}

@Component({
	selector: 'app-lista-facturas',
	templateUrl: './lista-facturas.component.html',
	styleUrls: ['./lista-facturas.component.scss']
})
export class ListaFacturasComponent implements OnInit {
	datosevent: any;
	evento: any;
	facturas: any;
	facturas_filtradas: any = new Map();
	facturas_filtradas_array: any[] = [];
	factlista: any;
	factura_response;
	emails: any;
	mensaje: any;
	spinner: boolean = false;
	// Grid variables
	gridOptions: IGridOptions;
	columns: IColumns[];
	exportExcel: IExportExcel;
	searchPanel: ISearchPanel;
	scroll: IScroll;
	toolbar: Toolbar[];
	columnHiding: IColumnHiding;
	Checkbox: ICheckbox;
	Editing: IEditing;
	Columnchooser: IColumnchooser;
	datosModificaFactura: any[];
	descargarExcel: boolean = true;

	subscribeOperacion: any;
	getStateOperacion: Observable<any>;
	Operacion: any;
	idOperacion: number;

	@ViewChild('drawer') drawer: MatDrawer;
	drawerMode: 'over' | 'side' = 'side';
	drawerOpened: boolean = true;
	private _unsubscribeAll: Subject<any> = new Subject<any>();
	@ViewChildren(FuseCardComponent, { read: ElementRef }) private _fuseCards: QueryList<ElementRef>;
	@ViewChild(MatPaginator) paginator: MatPaginator;


	stateCtrl = new FormControl('');
	filteredStates: Observable<State[]>;
	lstProducto: any = [];

	parametros: paramBusqueda = {
		tipoBusqueda: 0,
		busqueda: null,
		periodoAnio: null,
		periodoMes: null,
		RFC: null,
		lugarExpedicionCP: null,
		tipoFactura: null,
		EstatusFactura: null,
		formaPago: null,
		folioInicio: null,
		folioFin: null,
		fechaInicio: null,
		fechaFin: null
	}

	busquedaGeneral = new FormControl('', [Validators.required]);

	frmAnio = new FormControl(0);
	frmMes = new FormControl(0);
	frmRFC = new FormControl('');
	frmExpedicion = new FormControl('');
	frmDocumento = new FormControl(0);
	frmEstatus = new FormControl(0);
	frmPago = new FormControl('');
	frmFolioInicio = new FormControl(0);
	frmFolioFin = new FormControl(0);

	anios: any;
	meses: any;
	lugarExpedicion: any;
	tipoComprobante: any;
	estatusFactura: any;
	metodoPago: any;
	length: number;
	finalUrl: string;
	cambioPagina: boolean = true;
	pageSize: number = 50;
	idEmpresa: number;

	anio: any;
	mes: any;
	lugar: any;
	tipo: any;
	status: any;
	metodo: any;
	rfc: any;
	busqueda: any;
	selPdf: Uint8Array;
	configured: boolean = null;

	constructor(
		public dialog: MatDialog,
		private readonly store: Store<AppState>,
		private coalService: CoalService,
		private _snackBar: MatSnackBar,
		private baseService: BaseService,
		private route: Router,
		private httpClient: HttpClient,
		private sparroService: sparrowService,
		private _fuseMediaWatcherService: FuseMediaWatcherService,
		private srvcoal: CoalService,
		private facturaService: FacturaService,
		private fileService: FileService,
		private router: ActivatedRoute
	) {
		this.store.dispatch(AsignaBreadcrumb({
			breadcrumb: null
		}));

		this.router.paramMap.subscribe(params => {
			this.anio = params.get('anio');
			this.mes = params.get('mes');
			this.rfc = params.get('rfc');
			this.lugar = params.get('lugar');
			this.tipo = params.get('tipo');
			this.status = params.get('status');
			this.metodo = params.get('metodo');
			this.busqueda = params.get('busqueda');
		});


	}

	async ngOnInit() {
		this.baseService.postDetalleFactura(null);
		this.getStateOperacion = this.store.select(selectUtilsState);
		this.subscribeOperacion = this.getStateOperacion.subscribe((operacion) => {
			if (operacion.empresaSeleccionada === undefined) {
				this.configured = false;
				throw new Error('Empresa no configurada. Proceso interrumpido.');
			}
			else {
				this.configured = true;
				this.idOperacion = operacion.idOperacion;
				this.Operacion = operacion;
				this.idEmpresa = operacion?.empresaSeleccionada?.id;

			}
		});


		if (this.anio !== '0' || this.mes !== '0' || this.rfc !== '0' || this.lugar !== '0' || this.tipo !== '0' || this.status !== '0' || this.metodo !== '0') {
			this.parametros.tipoBusqueda = 2
		}

		if (this.busqueda !== '0') {
			this.busquedaGeneral.setValue(this.busqueda)
			this.parametros.tipoBusqueda = 1
			this.parametros.busqueda = this.busqueda
		}

		this.frmAnio.setValue(this.anio !== '0' ? this.anio : null)

		if (this.anio !== '0') {
			const body = {
				value: this.anio
			}
			this.onYearChange(body)
			this.frmMes.setValue(this.mes !== '0' ? this.mes : null)
		}

		this.frmRFC.setValue(this.rfc !== '0' ? this.anio : null)
		this.frmExpedicion.setValue(this.lugar !== '0' ? this.lugar : null)
		this.frmDocumento.setValue(this.tipo !== '0' ? this.tipo : null)
		this.frmEstatus.setValue(this.status !== '0' ? this.status : null)
		this.frmPago.setValue(this.metodo !== '0' ? this.metodo : null)


		this.parametros.periodoAnio = this.anio !== '0' ? this.anio : this.parametros.periodoAnio;
		this.parametros.periodoMes = this.mes !== '0' ? this.mes : this.parametros.periodoMes;
		this.parametros.RFC = this.rfc !== '0' ? this.rfc : this.parametros.RFC;
		this.parametros.lugarExpedicionCP = this.lugar !== '0' ? this.lugar : this.parametros.lugarExpedicionCP;
		this.parametros.tipoFactura = this.tipo !== '0' ? this.tipo : this.parametros.tipoFactura;
		this.parametros.EstatusFactura = this.status !== '0' ? this.status : this.parametros.EstatusFactura;
		this.parametros.formaPago = this.metodo !== '0' ? this.metodo : this.parametros.formaPago;


		await this.GetData(this.parametros);
		// this.GetProducto();
		this.GetDataCatalogos();

		this.filteredStates = this.stateCtrl.valueChanges.pipe(
			startWith(''),
			map(state => (state ? this._filterStates(state) : this.facturas_filtradas_array)),
		);

		// this.filteredStates = this.stateCtrl.valueChanges.pipe(
		// 	startWith(''),
		// 	map(state => (state ? this._filterStates(state) : this.facturas_filtradas_array)),
		// );

		// Subscribe to media changes
		// this._fuseMediaWatcherService.onMediaChange$
		//     .pipe(takeUntil(this._unsubscribeAll))
		//     .subscribe(({matchingAliases}) => {

		//         // Set the drawerMode and drawerOpened if the given breakpoint is active
		//         if ( matchingAliases.includes('md') )
		//         {
		//             this.drawerMode = 'side';
		//             this.drawerOpened = true;
		//         }
		//         else
		//         {
		//             this.drawerMode = 'over';
		//             this.drawerOpened = false;
		//         }
		//     });
	}

	private _filterStates(value: string): State[] {
		const filterValue = value.toUpperCase();
		const uniqueRfcMap = new Map();

		// Crear un conjunto único de RFCs y nombres
		for (const state of this.facturas) {
			if (!uniqueRfcMap.has(state.rfc)) {
				uniqueRfcMap.set(state.rfc, state);
			}
		}

		// Convertir el Map en un array y filtrar basándose en RFC o nombre
		return Array.from(uniqueRfcMap.values()).filter(
			state =>
				state.rfc.toUpperCase().includes(filterValue) ||
				state.nombre.toUpperCase().includes(filterValue)
		);
	}

	// private _filterStates(value: string): State[] {
	// 	const filterValue = value.toUpperCase();
	// 	const uniqueRfcMap = new Map();

	// 	// Crear un conjunto único de RFCs
	// 	for (const state of this.facturas) {
	// 		if (!uniqueRfcMap.has(state.rfc)) {
	// 			uniqueRfcMap.set(state.rfc, state);
	// 		}
	// 	}

	// 	// Convertir el Map en un array y filtrar basándose en el valor de entrada
	// 	return Array.from(uniqueRfcMap.values()).filter(state => state.rfc.toUpperCase().includes(filterValue));
	// }

	GetProducto(opcion: number = 1) {
		this.store.dispatch(MostrarSpinner());
		this.lstProducto.length = 0;
		// this.coalService.getService(`catalogo/GetSelProductoGrid?idOperacion=${this.idOperacion}`,).subscribe((res: any) => {
		// 	if (res.err) {
		// 		this.store.dispatch(OcultarSpinner());
		// 	} else if (res.excepcion) {
		// 		this.store.dispatch(OcultarSpinner());
		// 	} else {
		// 		this.lstProducto = res.recordsets[0]
		// 		this.store.dispatch(OcultarSpinner());
		// 	};
		// }, (error: any) => {
		// 	this.store.dispatch(OcultarSpinner());
		// });
	};

	buscarAvanzado() {
		this.parametros.tipoBusqueda = 2;
		this.cambioPagina = false;
		if (this.length > this.pageSize) this.paginator.firstPage();
		this.parametros.periodoAnio = (this.frmAnio.value == 0 || this.frmAnio.value === null || this.frmAnio.value === undefined) ? null : this.frmAnio.value;

		this.parametros.periodoMes = (this.frmMes.value == 0 || this.frmMes.value === null || this.frmMes.value === undefined) ? null : this.frmMes.value;

		this.parametros.RFC = (this.stateCtrl.value === '' || this.stateCtrl.value === null || this.stateCtrl.value === undefined) ? null : this.stateCtrl.value;

		this.parametros.lugarExpedicionCP = (this.frmExpedicion.value == '0' || this.frmExpedicion.value === '' || this.frmExpedicion.value === null || this.frmExpedicion.value === undefined) ? null : this.frmExpedicion.value;

		this.parametros.tipoFactura = (this.frmDocumento.value == 0 || this.frmDocumento.value === null || this.frmDocumento.value === undefined) ? null : this.frmDocumento.value;

		this.parametros.EstatusFactura = (this.frmEstatus.value == 0 || this.frmEstatus.value === null || this.frmEstatus.value === undefined) ? null : this.frmEstatus.value;

		this.parametros.formaPago = (this.frmPago.value == '0' || this.frmPago.value === '' || this.frmPago.value === null || this.frmPago.value === undefined) ? null : this.frmPago.value;

		if (this.frmFolioInicio.value == 0 || this.frmFolioInicio.value === null || this.frmFolioInicio.value === undefined) {
			if (this.frmFolioFin.value == 0 || this.frmFolioFin.value === null || this.frmFolioFin.value === undefined) {
				this.parametros.folioInicio = null;
				this.parametros.folioFin = null;
			}
			else {
				this._snackBar.open('Debes proporcionar el folio inicial', 'OK', { duration: 6000 });
				return false;
			}
		}
		else {
			if (this.frmFolioFin.value == 0 || this.frmFolioFin.value === null || this.frmFolioFin.value === undefined) {
				this._snackBar.open('Debes proporcionar el folio final', 'OK', { duration: 6000 });
				return false;
			}
			else {
				if (this.frmFolioFin.value > this.frmFolioInicio.value) {
					this.parametros.folioInicio = this.frmFolioInicio.value;
					this.parametros.folioFin = this.frmFolioFin.value;
				}
				else {
					this._snackBar.open('El folio final debe ser mayor que el inicial', 'OK', { duration: 6000 });
					return false;
				}
			}
		}
		// this.parametros.folioInicio = ( this.frmFolioInicio.value == '0' || this.frmFolioInicio.value === '' || this.frmFolioInicio.value === null || this.frmFolioInicio.value === undefined ) ? null : this.frmFolioInicio.value;

		// this.parametros.folioFin = ( this.frmFolioFin.value == '0' || this.frmFolioFin.value === '' || this.frmFolioFin.value === null || this.frmFolioFin.value === undefined ) ? null : this.frmFolioFin.value;

		this.GetData(this.parametros);
	}

	openSlide() {
		/*
		frmAnio = new FormControl('');
		frmMes = new FormControl('');
		frmRFC = new FormControl('');
		frmExpedicion = new FormControl('');
		frmDocumento = new FormControl('');
		frmEstatus = new FormControl('');
		frmPago = new FormControl('');
		frmFolioInicio = new FormControl('');
		frmFolioFin = new FormControl('');
		*/
		this.frmAnio.reset();
		this.frmMes.reset();
		this.stateCtrl.reset();
		this.stateCtrl.setValue('')
		this.frmExpedicion.reset();
		this.frmDocumento.reset();
		this.frmEstatus.reset();
		this.frmPago.reset();
		this.frmFolioInicio.reset();
		this.frmFolioFin.reset();

		this.drawerOpened = (this.drawerOpened) ? false : true;
	}

	cancelarAvanzado() {
		this.parametros = {
			tipoBusqueda: 0,
			busqueda: null,
			periodoAnio: null,
			periodoMes: null,
			RFC: null,
			lugarExpedicionCP: null,
			tipoFactura: null,
			EstatusFactura: null,
			formaPago: null,
			folioInicio: null,
			folioFin: null,
			fechaInicio: null,
			fechaFin: null
		}
		this.GetData(this.parametros);
		this.drawerOpened = (this.drawerOpened) ? false : true;
	}

	GetDataCatalogos() {

		this.store.dispatch(MostrarSpinner());
		this.spinner = true;

		this.srvcoal.getService(`fac-facturas/distinct-years?idEmpresa=${this.idEmpresa}`).subscribe((res: any) => {
			this.anios = res.data.attributes.years;
		}, (error: any) => {
			console.log("error ***************", error);
		});



		this.srvcoal.getService(`cat-metodo-pagos?populate=*`,).subscribe((res: any) => {
			if (res.err) {
				console.log("erro *************** 1")
			} else if (res.excepcion) {
				console.log("erro *************** 2")
			} else {
				this.metodoPago = res.data
			}
		}, (error: any) => {
			console.log("erro *************** 3", error)
		});

		this.srvcoal.getService(`cat-tipo-comprobantes?populate=*&filters[portal][$eq]=true`,).subscribe((res: any) => {
			if (res.err) {
				console.log("erro *************** 1")
			} else if (res.excepcion) {
				console.log("erro *************** 2")
			} else {
				this.tipoComprobante = res.data
				console.log('data report', res.data)
			}
		}, (error: any) => {
			console.log("erro *************** 3", error)
		});


		// this.srvcoal.getService(`ope-empresas?populate[ope_direccion_empresa][populate]=*
		// &filters[ope_empresa][id][$eq]=${this.idEmpresa}`,).subscribe((res: any) => {
		this.srvcoal.getService(`ope-empresas?populate[ope_direccion_empresas][populate]=*&filters[id][$eq]=${this.idEmpresa}`).subscribe((res: any) => {
			if (res.err) {
				console.log("erro *************** 1")
			} else if (res.excepcion) {
				console.log("erro *************** 2")
			} else {
				// this.lugarExpedicion = res.data.map(m => m.attributes.ope_direccion_empresas.data[0])
				this.lugarExpedicion = res.data.flatMap(m => m.attributes.ope_direccion_empresas.data);

				console.log('this.lugarExpedicion', this.lugarExpedicion)
			}
		}, (error: any) => {
			console.log("erro *************** 3", error)
		});

		this.srvcoal.getService(`fac-estatuses?populate=*`,).subscribe((res: any) => {
			if (res.err) {
				console.log("erro *************** 1")
			} else if (res.excepcion) {
				console.log("erro *************** 2")
			} else {
				this.estatusFactura = res.data
			}
		}, (error: any) => {
			console.log("erro *************** 3", error)
		});

		this.srvcoal.getService(`pro-productos?populate=*`)
			.subscribe((res: any) => {
				if (res.err) {
					console.log("erro *************** 1")
				} else if (res.excepcion) {
					console.log("erro *************** 2")
				} else {

					this.lstProducto = res.data
					this.store.dispatch(OcultarSpinner())


				}
			}, (error: any) => {
				this.store.dispatch(OcultarSpinner())
				this.spinner = false;
			});

		// this.coalService.getService("catalogo/GetSelFiltros").subscribe(
		// 	(data: any) => {
		// 		console.log("GetDataCatalogos", data);
		// 		// this.anios = data.recordsets[0];
		// 		this.lstProducto = data.recordsets[1];
		// 		// this.lugarExpedicion = data.recordsets[2];
		// 		// this.tipoComprobante = data.recordsets[3];
		// 		// this.estatusFactura = data.recordsets[4];
		// 		// this.metodoPago = data.recordsets[5];



		// 	}, (error: any) => {
		// 		this.store.dispatch(OcultarSpinner())
		// 		this.spinner = false;
		// 	});


	}

	onYearChange(event: any) {
		const selectedYear = event.value;
		// Asegúrate de que los nombres de los meses estén en el idioma que prefieras.
		const monthNames = [
			'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
			'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
		];

		this.srvcoal.getService(`fac-facturas/distinct-months?year=${selectedYear}&idEmpresa=${this.idEmpresa}`).subscribe((res: any) => {
			// Realiza las operaciones con los datos recibidos aquí
			this.meses = res.data.attributes.months.map((monthNumber: number) => monthNames[monthNumber - 1]);

			console.log('this.meses 1', this.meses);

			// Agregar la opción 'Todos' al principio del arreglo
			this.meses.unshift('Todos');

			console.log('this.meses 2', this.meses);
		}, (error: any) => {
			console.error("Error al obtener los datos:", error);
		});
	}

	GetData(param) {
		console.log('GetData()', param);
		// return false

		this.store.dispatch(MostrarSpinner());
		// this.spinner = true;
		// this.cambioPagina = tru
		this.facturas = [];
		const monthNames = {
			"enero": "01",
			"febrero": "02",
			"marzo": "03",
			"abril": "04",
			"mayo": "05",
			"junio": "06",
			"julio": "07",
			"agosto": "08",
			"septiembre": "09",
			"octubre": "10",
			"noviembre": "11",
			"diciembre": "12"
		};



		// let baseUrl = `fac-facturas?populate=*`;
		let baseUrl = `fac-facturas?${this.BuildPopulate()}`;

		let filters = [];

		filters.push(`filters[ope_empresa][id][$eq]=${this.idEmpresa}`);

		if (param.periodoAnio && param.periodoMes) {
			const selectedYear = param.periodoAnio;

			if (param.periodoMes === 'Todos') {
				// Si el mes es "Todos", establecer las fechas para todo el año
				const startDate = `${selectedYear}-01-01`;  // Primer día del año
				const endDate = `${selectedYear}-12-31`;    // Último día del año

				filters.push(`filters[fechaEmision][$gte]=${startDate}T00:00:01`);
				filters.push(`filters[fechaEmision][$lte]=${endDate}T23:59:59`);

			} else {
				const selectedMonthName = param.periodoMes.toLowerCase(); // Asegúrate de que sea en minúsculas para coincidir con las claves del objeto
				const selectedMonth = monthNames[selectedMonthName];

				const startDate = `${selectedYear}-${selectedMonth}-01`; // Primer día del mes
				const endDate = new Date(selectedYear, parseInt(selectedMonth), 0).toISOString().split('T')[0]; // Último día del mes

				filters.push(`filters[fechaEmision][$gte]=${startDate}T00:00:01`);
				filters.push(`filters[fechaEmision][$lte]=${endDate}T23:59:59`);
			}
		}

		// Verifica si `param.frmPago` está definido y no es nulo
		if (param.formaPago) {
			filters.push(`filters[cat_metodo_pago][id][$eq]=${param.formaPago}`);
		}

		if (param.RFC) {
			filters.push(`filters[cli_cliente][rfc][$contains]=${param.RFC}`);
		}

		if (param.lugarExpedicionCP) {
			filters.push(`filters[ope_direccion_empresa][id][$eq]=${param.lugarExpedicionCP}`);
		}

		if (param.tipoFactura) {
			filters.push(`filters[cat_tipo_comprobante][id][$eq]=${param.tipoFactura}`);
		}

		if (param.EstatusFactura) {
			filters.push(`filters[fac_estatus][id][$eq]=${param.EstatusFactura}`);
		}

		if (param.folioInicio && param.folioFin) {
			filters.push(`filters[folio][$gte]=${param.folioInicio}`);
			filters.push(`filters[folio][$lte]=${param.folioFin}`);
		}

		if (param.busqueda) {
			filters.push(`filters[$or][0][fac_factura_timbre][uuid][$contains]=${param.busqueda}&filters[$or][1][cli_cliente][nombre][$contains]=${param.busqueda}&filters[$or][2][cli_cliente][rfc][$contains]=${param.busqueda}`);

		}




		let filterUrl = filters.length ? '&' + filters.join('&') : '';


		// Concatena el filtro si existe
		this.finalUrl = `${baseUrl}${filterUrl}`;
		this.facturas = []
		this.srvcoal.getService(this.finalUrl + `&pagination[start]=0&pagination[limit]=50&sort=id:DESC`).subscribe((res: any) => {
			if (res.err) {
				console.log("erro *************** 1")
			} else if (res.excepcion) {
				console.log("erro *************** 2")
			} else {
				res.data.forEach(element => {
					let importe = 0;

					if (element.attributes.cat_tipo_comprobante.data.id == 3) {
						// Inicializamos la variable para la suma del importePagado
						let totalImportePagado = 0;

						// Verificamos si existe la relación fac_complemento_pagos y fac_com_pago_documentos
						if (element.attributes.fac_complemento_pagos?.data) {
							element.attributes.fac_complemento_pagos.data.forEach(pago => {
								if (pago.attributes.fac_com_pago_documentos?.data) {
									pago.attributes.fac_com_pago_documentos.data.forEach(documento => {
										totalImportePagado += documento.attributes.importePagado || 0;
									});
								}
							});
						}

						importe = totalImportePagado;
					}
					else {
						importe = (element.attributes.total !== null ? element.attributes.total : 0)
					}


					const datos = {
						serie: element.attributes.ope_direccion_serie.data ? element.attributes.ope_direccion_serie.data.attributes.nombre : '',
						folio: element.attributes.folio ? element.attributes.folio : '',
						rfc: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.attributes.rfc : '',
						rfcEmisor: element.attributes.ope_empresa?.data?.attributes?.rfc,
						nombre: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.attributes.nombre : '',
						email: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.attributes.email : '',
						fecha: element.attributes.fechaEmision ? element.attributes.fechaEmision : '',
						descripcion: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.attributes.nombre : '',
						accion: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.id : 0,
						tipoFactura: element.attributes.cat_tipo_comprobante.data ? element.attributes.cat_tipo_comprobante.data.id : 0,
						tipoFactura_nombre: element.attributes.cat_tipo_comprobante.data ? element.attributes.cat_tipo_comprobante.data.attributes.nombre : '',

						EstatusFactura: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.nombre : null,
						UUID: element.attributes.fac_factura_timbre?.data?.attributes?.uuid, // no se
						UUIDCancelado: null, // no se
						UUIDRelacionado: null,// no se
						clave: 16812,// no se
						cliente: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.id : null,
						condicionesPago: element.attributes.condicionesPago,
						fechaEmision: null, // no se
						fechaHoraRegistro: "04/12/2023 01:52:35",// no se
						fechaRegistro: "2023/12/04",// no se
						formaPago: element.attributes.cat_forma_pago.data ? element.attributes.cat_forma_pago.data.id : null,
						fultext: null,// no se
						idDatoGeneralFactura: 16715, // no se
						idEstatusFactura: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.id : null,
						idFactura: element.id,
						idFormaPago: element.attributes.cat_forma_pago.data ? element.attributes.cat_forma_pago.data.id : null,
						idSerie: element.attributes.ope_direccion_serie.data ? element.attributes.ope_direccion_serie.data.id : null,
						lugarExpedicion: element.attributes.ope_direccion_empresa.data ? element.attributes.ope_direccion_empresa.data.id : null,
						lugarExpedicionCP: "06280", // no se
						metodoPago: element.attributes.cat_metodo_pago.data ? element.attributes.cat_metodo_pago.data.id : null,
						metodoPago_nombre: element.attributes.cat_metodo_pago.data ? element.attributes.cat_metodo_pago.data.attributes.clave : null,

						moneda: element.attributes.cat_moneda.data ? element.attributes.cat_moneda.data.id : null,
						motivoCancelacion: null, // no se
						nombreBanco: element.attributes.nombreBanco,
						numeroCuenta: element.attributes.numeroCuentaPago,// no se
						numeroPedido: element.attributes.numeroPedido,
						observacion: element.attributes.observacion,
						periodoAnio: 2023,// no se
						periodoMes: 12,// no se
						tipoCambio: element.attributes.tipoCambio,
						tipo_factura: element.attributes.cat_tipo_comprobante.data ? element.attributes.cat_tipo_comprobante.data.attributes.nombre : '',
						xml_format: null,// no se,
						idFechaEmision: element.attributes.cat_fecha_emision.data ? element.attributes.cat_fecha_emision.data.id : null,
						fac_comp_pago: element.attributes.fac_complemento_pagos.data ? element.attributes.fac_complemento_pagos.data : [],
						confirmacion: element.attributes.confirmacion,
						cat_exportacion: element.attributes.cat_exportacion.data ? element.attributes.cat_exportacion.data : [],
						aplicaProductos: element.attributes.cat_tipo_comprobante.data.attributes.aplicaProductos !== null ? element.attributes.cat_tipo_comprobante.data.attributes.aplicaProductos : false,
						importe: importe,
						cat_global_periodicidad: element.attributes.cat_global_periodicidad,
						cat_global_me: element.attributes.cat_global_me,
						catGlobalAnio: element.attributes.catGlobalAnio,

						cuentaBanco: element.attributes.ope_empresa_banco.data ? element.attributes.ope_empresa_banco.data.id : null, // no se
						observaciones: element.attributes.ope_empresa_observacion.data ? element.attributes.ope_empresa_observacion.data.id : null,// no se
						ope_empresa_banco: element.attributes.ope_empresa_banco.data ? element.attributes.ope_empresa_banco.data.id : null,
						fac_factura_doc_relacionados: element.attributes.fac_factura_doc_relacionados.data ? element.attributes.fac_factura_doc_relacionados.data : [],

						CFDIRelacionados: element.attributes.cat_cfdi_relaciondo.data,
						idEmpresa: element.attributes.ope_empresa.data ? element.attributes.ope_empresa.data.id : null,
					}
					this.facturas.push(datos)
					this.length = res.meta.pagination.total//this.facturas.length
				});



				// Crear un conjunto único de RFCs
				for (const state of this.facturas) {
					if (!this.facturas_filtradas.has(state.rfc)) {
						this.facturas_filtradas.set(state.rfc, state);
					}
				}

				this.facturas_filtradas_array = Array.from(this.facturas_filtradas.values());

				this.Grid();
				this.store.dispatch(OcultarSpinner())
				this.spinner = false;
				this.cambioPagina = true
				setTimeout(() => {
					const correoFactura = localStorage.getItem('enviarCorreoFactura');
					const enviarCorreo = localStorage.getItem('enviarCorreoNuevaFactura');
					if (enviarCorreo) {
						const objFactura = JSON.parse(correoFactura);
						const factura = this.facturas.find(item => item.idFactura == objFactura.idFactura);
						this.openDialogEnvioMailIndividual(factura);
						localStorage.removeItem('enviarCorreoFactura');
						localStorage.removeItem('enviarCorreoNuevaFactura')
					}
				}, 200);

				if (this.parametros.tipoBusqueda != 2) {
					setTimeout(() => {
						this.drawerOpened = false;
					}, 1000);
				}
			}
		})
	}

	BuildPopulate() {
		return `
		populate[fac_complemento_pagos][fields][0]=id&
		populate[fac_complemento_pagos][fields][1]=createdAt&
		populate[fac_complemento_pagos][fields][2]=updatedAt&
		populate[fac_complemento_pagos][populate][fac_com_pago_documentos][fields][0]=importePagado&
		populate[fac_complemento_pagos][populate][fac_com_pago_documentos][fields][1]=createdAt&
		populate[ope_direccion_empresa][fields][0]=nombre&
		populate[ope_direccion_empresa][fields][1]=descripcion&
		populate[ope_direccion_empresa][fields][2]=createdAt&
		populate[ope_direccion_empresa][fields][3]=updatedAt&
		populate[cat_tipo_comprobante][fields][0]=nombre&
		populate[cat_tipo_comprobante][fields][1]=dataCfdiType&
		populate[cat_tipo_comprobante][fields][2]=orden&
		populate[cat_tipo_comprobante][fields][3]=createdAt&
		populate[cat_tipo_comprobante][fields][4]=updatedAt&
		populate[cat_tipo_comprobante][fields][5]=publishedAt&
		populate[cat_tipo_comprobante][fields][6]=portal&
		populate[cat_tipo_comprobante][fields][7]=masivo&
		populate[cat_tipo_comprobante][fields][8]=aplicaProductos&
		populate[ope_direccion_serie][fields][0]=nombre&
		populate[ope_direccion_serie][fields][1]=descripcion&
		populate[ope_direccion_serie][fields][2]=folio&
		populate[ope_direccion_serie][fields][3]=createdAt&
		populate[ope_direccion_serie][fields][4]=updatedAt&
		populate[cli_cliente][fields][0]=nombre&
		populate[cli_cliente][fields][1]=rfc&
		populate[cli_cliente][fields][2]=email&
		populate[fac_estatus][fields][0]=nombre&
		populate[fac_estatus][fields][1]=esTimbrado&
		populate[fac_estatus][fields][2]=estadoComprobante&
		populate[cat_metodo_pago][fields][0]=clave&
		populate[cat_metodo_pago][fields][1]=nombre&
		populate[cat_forma_pago][fields][0]=clave&
		populate[cat_forma_pago][fields][1]=descripcion&
		populate[cat_forma_pago][fields][2]=bancarizado&
		populate[cat_moneda][fields][0]=clave&
		populate[cat_moneda][fields][1]=descripcion&
		populate[fac_factura_timbre][fields][0]=uuid&
		populate[fac_factura_timbre][fields][1]=sello&
		populate[fac_factura_timbre][fields][2]=certificado&
		populate[xml][fields][0]=name&
		populate[xml][fields][1]=url&
		populate[cat_fecha_emision][fields][0]=nombre&
		populate[cat_fecha_emision][fields][1]=dias&
		populate[fac_factura_productos][fields][0]=noIdentificacion&
		populate[fac_factura_productos][fields][1]=nombre&
		populate[fac_factura_productos][fields][2]=precioUnitario&
		populate[fac_factura_productos][fields][3]=cantidad&
		populate[fac_factura_productos][fields][4]=descuento&
		populate[cat_exportacion][fields][0]=clave&
		populate[cat_exportacion][fields][1]=nombre&
		populate[ope_empresa_banco][fields][0]=nombre&
		populate[ope_empresa_observacion][fields][0]=descripcion&
		populate[fac_factura_doc_relacionados][fields][0]=id&
		populate[fac_factura_doc_relacionados][fields][1]=createdAt&
		populate[fac_factura_doc_relacionados][fields][2]=updatedAt&
		populate[fac_factura_doc_relacionados][fields][3]=publishedAt&
		populate[cat_cfdi_relaciondo][fields][0]=id&
		populate[cat_cfdi_relaciondo][fields][1]=nombre&
		populate[ope_empresa][fields][0]=rfc&
		populate[ope_empresa][fields][1]=razonSocial&
		populate[ope_empresa][fields][2]=nombreComercial&
		populate[ope_empresa][fields][3]=email&
		populate[ope_empresa][fields][4]=telefono
		`;
	}

	handlePageEvent(e: PageEvent) {

		// this.cambioPagina = true;

		this.facturas = [];
		// this.pageEvent = e;
		this.length = e.length;
		// this.pageSize = e.pageSize;
		// this.pageIndex = e.pageIndex;
		var start = (e.pageIndex === 0 ? 0 : (e.pageIndex * this.pageSize))
		if (this.cambioPagina) {
			this.store.dispatch(MostrarSpinner())
			this.srvcoal.getService(this.finalUrl + `&pagination[start]=${start}&pagination[limit]=${this.pageSize}&sort=id:DESC`).subscribe((res: any) => {
				if (res.err) {
					console.log("erro *************** 1")
				} else {
					res.data.forEach(element => {
						const datos = {
							serie: element.attributes.ope_direccion_serie.data ? element.attributes.ope_direccion_serie.data.attributes.nombre : '',
							folio: element.attributes.folio ? element.attributes.folio : '',
							rfc: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.attributes.rfc : '',
							nombre: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.attributes.nombre : '',
							email: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.attributes.email : '',
							fecha: element.attributes.fechaEmision ? element.attributes.fechaEmision : '',
							descripcion: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.attributes.nombre : '',
							accion: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.id : 0,
							tipoFactura: element.attributes.cat_tipo_comprobante.data ? element.attributes.cat_tipo_comprobante.data.id : 0,
							tipoFactura_nombre: element.attributes.cat_tipo_comprobante.data ? element.attributes.cat_tipo_comprobante.data.attributes.nombre : '',

							CFDIRelacionados: element.attributes.cat_cfdi_relaciondo.data,
							EstatusFactura: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.nombre : null,
							UUID: null, // no se
							UUIDCancelado: null, // no se
							UUIDRelacionado: null,// no se
							clave: 16812,// no se
							cliente: element.attributes.cli_cliente.data ? element.attributes.cli_cliente.data.id : null,
							condicionesPago: element.attributes.condicionesPago,
							cuentaBanco: element.attributes.ope_empresa_banco.data ? element.attributes.ope_empresa_banco.data.id : null, // no se
							fechaEmision: null, // no se
							fechaHoraRegistro: "04/12/2023 01:52:35",// no se
							fechaRegistro: "2023/12/04",// no se
							formaPago: element.attributes.cat_forma_pago.data ? element.attributes.cat_forma_pago.data.id : null,
							fultext: null,// no se
							idDatoGeneralFactura: 16715, // no se
							idEstatusFactura: element.attributes.fac_estatus.data ? element.attributes.fac_estatus.data.id : null,
							idFactura: element.id,
							idEmpresa: element.attributes.ope_empresa.data ? element.attributes.ope_empresa.data.id : null,
							idFormaPago: element.attributes.cat_forma_pago.data ? element.attributes.cat_forma_pago.data.id : null,
							idSerie: element.attributes.ope_direccion_serie.data ? element.attributes.ope_direccion_serie.data.id : null,
							lugarExpedicion: element.attributes.ope_direccion_empresa.data ? element.attributes.ope_direccion_empresa.data.id : null,
							lugarExpedicionCP: "06280", // no se
							metodoPago: element.attributes.cat_metodo_pago.data ? element.attributes.cat_metodo_pago.data.id : null,
							metodoPago_nombre: element.attributes.cat_metodo_pago.data ? element.attributes.cat_metodo_pago.data.attributes.clave : null,

							moneda: element.attributes.cat_moneda.data ? element.attributes.cat_moneda.data.id : null,
							motivoCancelacion: null, // no se
							nombreBanco: element.attributes.nombreBanco,
							numeroCuenta: element.attributes.numeroCuentaPago,// no se
							numeroPedido: element.attributes.numeroPedido,
							observacion: element.attributes.observacion,
							observaciones: element.attributes.ope_empresa_observacion.data ? element.attributes.ope_empresa_observacion.data.id : null,// no se
							periodoAnio: 2023,// no se
							periodoMes: 12,// no se
							tipoCambio: element.attributes.tipoCambio,
							tipo_factura: element.attributes.cat_tipo_comprobante.data ? element.attributes.cat_tipo_comprobante.data.nombre : '',
							xml_format: null,// no se,
							ope_empresa_banco: element.attributes.ope_empresa_banco.data ? element.attributes.ope_empresa_banco.data.id : null,
							idFechaEmision: element.attributes.cat_fecha_emision.data ? element.attributes.cat_fecha_emision.data.id : null,
							fac_comp_pago: element.attributes.fac_complemento_pagos.data ? element.attributes.fac_complemento_pagos.data : [],
							fac_factura_doc_relacionados: element.attributes.fac_factura_doc_relacionados.data ? element.attributes.fac_factura_doc_relacionados.data : [],
							confirmacion: element.attributes.confirmacion,
							cat_exportacion: element.attributes.cat_exportacion.data ? element.attributes.cat_exportacion.data : [],
							aplicaProductos: element.attributes.cat_tipo_comprobante.data.attributes.aplicaProductos !== null ? element.attributes.cat_tipo_comprobante.data.attributes.aplicaProductos : false,
							importe: element.attributes.total !== null ? element.attributes.total : 0,
							cat_global_periodicidad: element.attributes.cat_global_periodicidad,
							cat_global_me: element.attributes.cat_global_me,
							catGlobalAnio: element.attributes.catGlobalAnio

						}
						this.facturas.push(datos)
					});

					setTimeout(() => {
						this.store.dispatch(OcultarSpinner())
					}, 500);
				}
			})
		}

	}

	openSuccess(respuesta, data) {
		const dialogRef = this.dialog.open(SuccessFacturacionComponent, {
			width: '60%',
			data: { error: respuesta, data: data }
		});

		dialogRef.afterClosed().subscribe(result => {

		});
	}

	botones: IBotones = {
		editar: null,
		pdf: null,
		xml: null,
		email: null,
		cancelar: null,
		eliminar: null,
		acuse: null,
		duplicar: null
	};

	onRowSelectionChanged(e: any) {
		if (e === 1) {
			this.botones['editar'].option("visible", true);
			this.botones['pdf'].option("visible", true);
			this.botones['xml'].option("visible", false);
			this.botones['email'].option("visible", false);
			this.botones['cancelar'].option("visible", false);
			this.botones['eliminar'].option("visible", true);
			this.botones['acuse'].option("visible", false);
			this.botones['duplicar'].option("visible", false);
		}
		else if (e === 2) {
			this.botones['editar'].option("visible", false);
			this.botones['pdf'].option("visible", true);
			this.botones['xml'].option("visible", true);
			this.botones['email'].option("visible", true);
			this.botones['cancelar'].option("visible", true);
			this.botones['eliminar'].option("visible", false);
			this.botones['acuse'].option("visible", false);
			this.botones['duplicar'].option("visible", true);
		}
		else if (e === 3) {
			this.botones['editar'].option("visible", false);
			this.botones['pdf'].option("visible", true);
			this.botones['xml'].option("visible", true);
			this.botones['email'].option("visible", true);
			this.botones['cancelar'].option("visible", false);
			this.botones['eliminar'].option("visible", false);
			this.botones['acuse'].option("visible", true);
			this.botones['duplicar'].option("visible", true);
		}
		else {
			this.botones['editar'].option("visible", false);
			this.botones['pdf'].option("visible", false);
			this.botones['xml'].option("visible", false);
			this.botones['email'].option("visible", false);
			this.botones['cancelar'].option("visible", false);
			this.botones['eliminar'].option("visible", false);
			this.botones['acuse'].option("visible", false);
			this.botones['duplicar'].option("visible", false);
		}
	}

	getButton(btn: { text: string, accion: string }) {
		return {
			location: 'after',
			widget: 'dxButton',
			locateInMenu: 'auto',
			options: {
				text: btn.text,
				onInitialized: (e: any) => this.botones[btn.accion as keyof IBotones] = e.component,
				onClick: this.receiveMessage.bind(this, btn.accion)
			},
			visible: false,
			name: 'simple',
			name2: 'multiple'
		}
	}

	Grid() {
		//console.log("Entra a grid");
		this.toolbar = [];
		this.toolbar.push(
			this.getButton({ text: 'Editar', accion: 'editar' }),
			this.getButton({ text: 'PDF', accion: 'pdf' }),
			this.getButton({ text: 'XML', accion: 'xml' }),
			this.getButton({ text: 'Enviar por correo', accion: 'email' }),
			this.getButton({ text: 'Cancelar', accion: 'cancelar' }),
			this.getButton({ text: 'Eliminar', accion: 'eliminar' }),
			this.getButton({ text: 'Acuse de cancelacion', accion: 'acuse' }),
			this.getButton({ text: 'Duplicar', accion: 'duplicar' }),
		);
		/*
		Columnas de la tabla
		*/
		try {
			this.columns = [
				// {
				// 	caption: 'Clave',
				// 	dataField: 'clave',
				// 	allowEditing: false
				// },
				{
					caption: 'Tipo Factura',
					dataField: 'tipoFactura_nombre'
				},
				{
					caption: 'Metodo de pago',
					dataField: 'metodoPago_nombre'
				},
				{
					caption: 'Serie',
					dataField: 'serie'
				},
				{
					caption: 'Folio',
					dataField: 'folio'
				},
				{
					caption: 'RFC Receptor',
					dataField: 'rfc'
				},
				{
					caption: 'Nombre',
					dataField: 'nombre',
					name: 'nombre'
				},
				{
					caption: 'Importe',
					dataField: 'importe',
					dataType: TiposdeDato.number,
					format: TiposdeFormato.moneda
				},
				{
					caption: 'Fecha',
					dataField: 'fecha',
					dataType: TiposdeDato.date,
					format: TiposdeFormato.ymd

				},
				{
					caption: 'Estatus',
					dataField: 'descripcion',
					cellTemplate: 'templateEstatus'
				},
				// {
				// 	caption: 'Opciones',
				// 	dataField: 'accion',
				// 	allowEditing: false,
				// 	cellTemplate: 'templateEditar'
				// }

			];
			/*
			Parametros de Paginacion de Grit
			*/
			const pageSizes = ['10', '25', '50', '100'];

			/*
			Parametros de Exploracion
			*/
			this.exportExcel = { enabled: false, fileName: 'Facturas' };
			// ******************PARAMETROS DE COLUMNAS RESPONSIVAS EN CASO DE NO USAR HIDDING PRIORITY**************** */
			this.columnHiding = { hide: true };
			// ******************PARAMETROS DE PARA CHECKBOX**************** */
			this.Checkbox = { checkboxmode: 'multiple' };  // *desactivar con none / multiple*/
			// ******************PARAMETROS DE PARA EDITAR GRID**************** */
			this.Editing = { allowupdate: false }; // *cambiar a batch para editar varias celdas a la vez*/
			// ******************PARAMETROS DE PARA SELECCION DE COLUMNAS**************** */
			this.Columnchooser = { columnchooser: true };

			/*
			Parametros de Search
			*/
			this.searchPanel = {
				visible: false,
				filterRow: false,
				filterHeader: false
			};

			this.factlista = true;
		} catch (error) {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 1 }));
		}
	}

	searchGeneral() {
		if (!this.busquedaGeneral.hasError('required')) {
			this.parametros.tipoBusqueda = 1;
			this.parametros.busqueda = this.busquedaGeneral.value;

			this.GetData(this.parametros);
		}
	}

	datosMessage($event) {
		try {
			if ($event.data.length == 1) {
				const fac = $event.data[0];
				this.onRowSelectionChanged(fac.idEstatusFactura);
			}
			this.datosevent = $event.data;
		} catch (error) {
			this.Excepciones(error, 1);
		}
	}

	modificar(e) {
		//;
		this.baseService.postDetalleFactura(null);
		this.baseService.postDetalleFactura(this.datosevent);
		this.route.navigateByUrl(`factura/nueva/0`);
	}

	descargarxml($event) {
		try {
			this.evento = $event.event;
			if ($event === 'XML') {
				this.store.dispatch(MostrarSpinner());
				this.spinner = true;
				for (let index = 0; index < this.datosevent.length; index++) {
					//Variables
					var fileToExport = new Blob([this.datosevent[index].xml_format], { type: "text/xml" });
					var a = document.createElement("a");
					a.href = URL.createObjectURL(fileToExport);
					a.target = "_blank";
					a.download = this.datosevent[index].rfc + '-' + this.datosevent[index].nombre + ".xml";
					a.click();
				}
				this.store.dispatch(OcultarSpinner())
				this.spinner = false;
			}
		} catch (error) {
			this.Excepciones(error, 1);
		}
	}

	descargaXML(datos) {
		if (datos.xml_format === undefined || datos.xml_format === null || datos.xml_format == '') {
			this._snackBar.open('XML no disponible', 'OK', { duration: 50000 });
		}
		else {
			this.store.dispatch(MostrarSpinner());
			var fileToExport = new Blob([datos.xml_format], { type: "text/xml" });
			var a = document.createElement("a");
			a.href = URL.createObjectURL(fileToExport);
			a.target = "_blank";
			a.download = datos.UUID + '-' + datos.rfc + '-' + datos.nombre + ".xml";
			a.click();
			this.store.dispatch(OcultarSpinner())
		}
	}

	descargaArchivo(fac) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getFacturaXml(fac.idFactura).then(data => {
			if (data != null && data.length > 0) {
				var file = data[0];
				/*this.fileService.downloadFile(file.url, file.name).subscribe({
					next: res => { console.log(res); },
					error: err => { console.log(err); }
				});*/

				this.fileService.getFileBlob(file.url).then(data => {
					var element = document.createElement('a');
					var blob = new Blob([data], {
						type: 'text/xml'
					});
					var url = URL.createObjectURL(blob);
					element.href = url;
					element.setAttribute('download', file.name);
					document.body.appendChild(element);
					element.click();
					this.store.dispatch(OcultarSpinner());
				}).catch(err => {
					console.log(err);
					this._snackBar.open(`Ocurrió un error al descargar el archivo: ${err.error?.error?.error?.message}`, 'OK', { duration: 5000 });
					this.store.dispatch(OcultarSpinner());
				});
			} else {
				this._snackBar.open(`No existe el archivo:`, 'OK', { duration: 5000 });
				this.store.dispatch(OcultarSpinner());
			}
		}).catch(err => {
			console.log(err);
			this._snackBar.open(`Ocurrió un error al descargar el archivo: ${err.error?.error?.error?.message}`, 'OK', { duration: 5000 });
			this.store.dispatch(OcultarSpinner());
		});
	}

	receiveMessage($event) {
		try {
			this.evento = $event;
			if (!(this.datosevent instanceof Array && this.datosevent.length > 0)) return;
			const fac = this.datosevent[0];
			if ($event === 'editar') {
				this.modificar($event);
			}
			else if ($event === 'pdf') {

				for (let index = 0; index < this.datosevent.length; index++) {
					/*switch (this.datosevent[index].tipoFactura_nombre) {
						case "Factura":
							this.facturaF(this.datosevent[index]);
							break;
						case "Nota de Crédito":
							this.facturaF(this.datosevent[index]);
							break;
						case "Complemento de Pago":
							this.facturaC(this.datosevent[index]);
							break;
					}*/
					switch (this.datosevent[index].tipoFactura) {
						case 1:
							this.facturaF(this.datosevent[index]);
							break;
						case 2:
							this.facturaF(this.datosevent[index]);
							break;
						case 3:
							this.facturaC(this.datosevent[index]);
							break;
						case 5:
							this.facturaF(this.datosevent[index]);
							break;
					}
				}
			}
			else if ($event === 'xml') {
				for (const fac of this.datosevent) {
					this.descargaArchivo(fac);
				}
			}
			else if ($event === 'email') {
				this.sendEmail(fac);
			}
			else if ($event === 'cancelar') {
				this.cancelarCfdi(fac);
			}
			else if ($event === 'eliminar') {
				this.archivarCfdi(fac)
			}
			else if ($event === 'acuse') {
				this.estatusCFDI(fac);
			}
			else if ($event === 'duplicar') {
				this.duplicarCFDI(fac);
			}
		} catch (error) {
			this.Excepciones(error, 1);
		}
	}

	descargaPDF(option: any) {
		switch (option.tipoFactura) {
			case 1:
				this.facturaF(option);
				break;
			case 2:
				this.facturaF(option);
				break;
			case 3:
				this.facturaC(option);
				break;
			case "Complemento Carta Porte":
				this.facturaComplementoPago(option)
				break;
			default:
				this.facturaF(option);
				break;
		}
	}
	facturaComplementoPago(factura) {
		var data;
		var body = { idFactura: factura.clave }
		this.coalService.postService(`catalogo/SelComplementoPorteFactrua`, body).subscribe((res: any) => {
			if (res.err) {
				this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
			} else if (res.excepcion) {
				this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
			} else {
				data = res.recordsets;
				this.sparroService.getReport("reportes/CallFeatureNewComplementoPorte", data, "Test Reporte").then((res: any) => {
					this._snackBar.open(`${res}`, 'OK', { duration: 1000 });
				}).catch(error => {
					this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
				});
			}
			this.store.dispatch(OcultarSpinner());
		}, (error: any) => {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			this.store.dispatch(OcultarSpinner())
		});
	}
	facturaC(factura) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getComplementoPagoPdf(factura.idFactura).then((body: any) => {
			var name = body.uuid ?? formatDate(new Date(), 'dd/MM/yyyy', 'es-MX');
			this.sparroService.getReport("reportes/CallFeatureNew", body.body, name).then((res: any) => {
				//this.store.dispatch(OcultarSpinner());
				this._snackBar.open(`${res}`, 'OK', { duration: 1000 });
			}).catch(error => {
				//this.store.dispatch(OcultarSpinner());
				this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
			});
		}).catch(error => {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			this.store.dispatch(OcultarSpinner());
			this._snackBar.open("Ocurrio un error al descargar el archivo pdf.", 'OK', { duration: 5000 });
		});
	}
	facturaF(factura) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getFacturaPdf(factura.idFactura).then((factura_response: any) => {
			var name = factura_response[0][0]?.uuid ?? ((factura_response[0][0]?.serie1 + factura_response[0][0]?.folio1) + " " + formatDate(new Date(), 'dd/MM/yyyy', 'es-MX'));
			this.sparroService.getReport("reportes/SelPdf", factura_response, name).then((res: any) => {
				//this.store.dispatch(OcultarSpinner());
				this._snackBar.open(`${res}`, 'OK', { duration: 1000 });
			}).catch(error => {
				//this.store.dispatch(OcultarSpinner());
				this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
			});
		}).catch(error => {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			this.store.dispatch(OcultarSpinner());
			this._snackBar.open("Ocurrio un error al descargar el archivo pdf.", 'OK', { duration: 5000 });
		});
	}

	duplicarCFDI(e) {
		localStorage.setItem("duplicar", "1")
		this.baseService.postDetalleFactura(null);
		this.baseService.postDetalleFactura([e]);
		this.route.navigateByUrl(`factura/nueva/0`);
	}

	sendEmail(datos) {
		this.openDialogEnvioMailIndividual(datos);
	}

	SendMailFacturasIndividualFacturaNormal_back(facturadata) {
		if (facturadata.xml_format === undefined || facturadata.xml_format === null || facturadata.xml_format == '') {
			this._snackBar.open('La factura aún no esta timbrada', 'OK', { duration: 5000 });
		}
		else {
			try {
				let data = {
					clave: facturadata.clave
				}
				this.store.dispatch(MostrarSpinner());
				this.spinner = true;
				this.coalService.postService("operacion/GetReporteFactura", data).subscribe(
					(response: any) => {
						//console.log(response);
						this.factura_response = response.recordsets;
						let senddata = {
							from: '"Envio de Facturas "<testerebo@gmail.com>',
							correos: this.emails,
							asunto: 'Envio Sparrow : Factura',
							text: this.mensaje,
							namePDF: facturadata.nombre + '.pdf',
							nameXML: facturadata.rfc + '-' + facturadata.nombre + ".xml",
							xml: facturadata.xml_format,
							pdfdata: this.factura_response
						}
						//const formData = new FormData();
						//formData.append('json', JSON.stringify(senddata));
						this.httpClient.post(environment.sparrowreport + 'EmailSender/SendEmail', senddata).subscribe(
							(data: any) => {
								//console.log(data);

								this.store.dispatch(OcultarSpinner())
								this.spinner = false;

								return this._snackBar.open('Factura enviada con éxito', 'OK', { duration: 5000 });
							}, (error: any) => {
								this.store.dispatch(OcultarSpinner())
								this.spinner = false;
							}
						);
					}, (error: any) => {
						this.store.dispatch(OcultarSpinner())
						this.spinner = false;
						//console.log(error);
					});
			} catch (error) {
				this.Excepciones(error, 1);
			}
		}

	}

	SendMailFacturasIndividualFacturaNormal(facturadata, result: DialogData) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getFactura(facturadata.idFactura).then((factura: any) => {
			var factura_response = this.facturaService.mapFacturaPdf(factura);
			var name = factura_response[0][0]?.uuid ?? ((factura_response[0][0]?.serie1 + factura_response[0][0]?.folio1) + " " + formatDate(new Date(), 'dd/MM/yyyy', 'es-MX'));
			this.sparroService.getReportBase64("reportes/SelPdf", factura_response, name).then((data: Uint8Array) => {
				this.selPdf = data;
				var b64encoded = btoa(data.reduce((data, byte) => data + String.fromCharCode(byte), ''));
				const atachmentPdf = {
					content: b64encoded,
					filename: name + ".pdf",
					contentType: 'application/pdf',
					disposition: 'attachment'
				};
				var file = factura.xml[0];
				this.fileService.getFileBase64(file.url).then(data => {
					const atachmentXml = {
						content: data,
						filename: file.name,
						contentType: "text/xml",
						disposition: 'attachment'
					};
					// [ { email: '', name: 'John Doe' } ],
					const to = result.emails.split(",").map(email => ({ email: email }));
					const cc = result.cc.trim().length > 0 ? result.cc.split(",").map(email => ({ email: email })) : [];
					//const content = { type: 'text/html', value: '<p>Hello from Twilio SendGrid!</p><p>Sending with the email service trusted by developers and marketers for <strong>time-savings</strong>, <strong>scalability</strong>, and <strong>delivery expertise</strong>.</p><p>%open-track%</p>' };

					const email = {
						to: to,
						cc: cc,
						subject: result.asunto,
						//content: [content],
						attachments: [atachmentPdf, atachmentXml],
						emisor: factura_response[1][0],
						receptor: factura_response[2][0],
						mensaje: result.mensaje,
						oferta: ""
					};
					this.coalService.postService("fac-facturas/sendFactura", email).subscribe({
						next: response => {
							this.store.dispatch(OcultarSpinner());
							this._snackBar.open("Se ha enviado la factura correctamente.", 'OK', { duration: 5000 });
						},
						error: error => {
							console.log(error);
							this.store.dispatch(OcultarSpinner());
							this._snackBar.open(`Ocurrió un error al enviar la factura ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
						}
					});

					let formData = new FormData();
					formData.append('from', '"Envio de Facturas "<testerebo@gmail.com>');
					formData.append('correos', this.emails);
					formData.append('asunto', 'Envio Sparrow : Factura');
					formData.append('text', this.mensaje);
					formData.append('namePDF', atachmentPdf.filename);
					formData.append('nameXML', atachmentXml.filename);
					formData.append('pdfdata', new Blob([atachmentPdf.content], { type: atachmentPdf.contentType }));
					formData.append('xmldata', new Blob([atachmentXml.content], { type: atachmentXml.contentType }));

					this.httpClient.post(environment.sparrowreport + 'EmailSender/SendEmail', formData).subscribe(
						(data: any) => {
							this.store.dispatch(OcultarSpinner());
							this.spinner = false;
							return this._snackBar.open('Factura enviada con éxito', 'OK', { duration: 5000 });
						}, (error: any) => {
							this.store.dispatch(OcultarSpinner());
							this.spinner = false;
						}
					);
				}).catch(error => {
					this.store.dispatch(OcultarSpinner());
					this._snackBar.open(`Ocurrió un error al obtener el archivo xml: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
				});
			}).catch(error => {
				this.store.dispatch(OcultarSpinner());
				this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
			});
		}).catch(error => {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			this.store.dispatch(OcultarSpinner());
			this._snackBar.open(`Ocurrió un error al obtener datos del comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
		});
	}

	SendMailFacturasIndividualFacturaComplemento(facturadata, result: DialogData) {
		this.store.dispatch(MostrarSpinner());
		this.facturaService.getComplementoPago(facturadata.idFactura).then((factura: any) => {
			var comp = this.facturaService.mapComplementoPagoPdf(factura);
			var name = comp.uuid ?? formatDate(new Date(), 'dd/MM/yyyy', 'es-MX');
			this.sparroService.getReportBase64("reportes/CallFeatureNew", comp.body, name).then((data: Uint8Array) => {
				var b64encoded = btoa(data.reduce((data, byte) => data + String.fromCharCode(byte), ''));
				const atachmentPdf = {
					content: b64encoded,
					filename: name + ".pdf",
					type: 'application/pdf',
					disposition: 'attachment'
				};
				var file = factura.xml[0];
				this.fileService.getFileBase64(file.url).then(data => {
					const atachmentXml = {
						content: data,
						filename: file.name,
						type: "text/xml",
						disposition: 'attachment'
					};
					// [ { email: '', name: 'John Doe' } ],
					const to = result.emails.split(",").map(email => ({ email: email }));
					const cc = result.cc.trim().length > 0 ? result.cc.split(",").map(email => ({ email: email })) : [];
					//const content = { type: 'text/html', value: '<p>Hello from Twilio SendGrid!</p><p>Sending with the email service trusted by developers and marketers for <strong>time-savings</strong>, <strong>scalability</strong>, and <strong>delivery expertise</strong>.</p><p>%open-track%</p>' };
					const email = {
						to: to,
						cc: cc,
						subject: result.asunto,
						//content: [content],
						attachments: [atachmentPdf, atachmentXml],
						emisor: comp.body.emisor,
						receptor: comp.body.receptor,
						mensaje: result.mensaje,
						oferta: ""
					};
					this.coalService.postService("fac-facturas/sendFactura", email).subscribe({
						next: response => {
							this.store.dispatch(OcultarSpinner());
							this._snackBar.open("Se ha enviado el complemento de pago coreectamente.", 'OK', { duration: 5000 });
						},
						error: error => {
							console.log(error);
							this.store.dispatch(OcultarSpinner());
							this._snackBar.open(`Ocurrió un error al enviar el complemento de pago ${error?.error?.error?.message}`);
						}
					});
				}).catch(error => {
					this.store.dispatch(OcultarSpinner());
					this._snackBar.open(`Ocurrió un error al obtener el archivo xml: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
				});
			}).catch(error => {
				this.store.dispatch(OcultarSpinner());
				this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
			});
		}).catch(error => {
			this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			this.store.dispatch(OcultarSpinner());
			this._snackBar.open(`Ocurrió un error al obtener datos del comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
		});
	}

	cancelarCfdi = data => {
		this.dialoCacelaCFDI4(this.datosevent)
	};

	dialoCacelaCFDI4(data) {
		const dialogRef = this.dialog.open(CancelaCFDI4Component, {
			width: '700px',
			data: {
				idEmpresa: this.idEmpresa
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result.success == 1) {
				const body = {
					idFactura: data[0].idFactura,
					rfcEmisor: data[0].rfcEmisor,
					folioUUID: data[0].UUID,
					motivoCancelacion: result.data.cancelReason,
					folioUUIDSustitucion: result.data.relatedCFDI
				}
				this.ejecutaCancelacion(body)
			}
			else {
				this._snackBar.open("Se ha suspendido la cancelación de la factura.", 'OK', { duration: 5000 });

			}
		});
	}

	archivarCfdi = data => {
		this.dialogArchivaCFDI4(this.datosevent)
	};

	dialogArchivaCFDI4(data) {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '700px',
			data: '¿Seguro que desea eliminar este borrador?'
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result == 1) {
				const body = {
					idFactura: data[0].idFactura,
				}
				this.ejecutaArchivacion(body)
			}
			else {
				this._snackBar.open("Se ha suspendido la eliminación de la factura.", 'OK', { duration: 5000 });

			}
		});
	}

	ejecutaArchivacion(data) {
		console.log('ejecutaArchivacion', data);

		this.store.dispatch(MostrarSpinner());
		this.coalService.deleteService(`fac-facturas/${data.idFactura}`).subscribe((res: any) => {
			this.store.dispatch(OcultarSpinner());
			this._snackBar.open('Factura eliminada correctamente');
			this.GetData(this.parametros);
		}, (error: any) => {
			this.store.dispatch(OcultarSpinner());
			this._snackBar.open(`Ocurrió un error al eliminar la factura ${error?.error?.error?.message}`);
		})
	}

	ejecutaCancelacion(data) {
		this.store.dispatch(MostrarSpinner());
		this.spinner = true;
		this.coalService.postService("fac-factura-xmls/cancel40", data).subscribe(async (res: any) => {
			this.store.dispatch(OcultarSpinner())
			this.spinner = false;
			this._snackBar.open(res.msj, 'OK', { duration: 5000 });

			// if (res.success == 1) {
			// 	let body = {
			// 		folio_fiscal: 'D99B1A55-5161-430C-9046-8BCD6C94EE7D',
			// 		rfcreceptor: 'UTM010711E2A',
			// 		rfcemisor: 'CUUE870528HL7',
			// 		estcfdi: 'Cancelado',
			// 		estcancelacion: 'Cancelado sin aceptación',
			// 		msgerror: '',
			// 		fecha: '30/08/2022 23:58:41',
			// 		sellodigitalsat: '0IE97Q/H4TWoE/PPJUgcNuf8hk4n/GwliEw7MWhcPoJFlgmvoPp8SfrUr/MaihUM8CVLehhagqCnGgFmyVltEA=='
			// 	};

			// 	// await this.sparroService.getReport("reportes/CallFeatureCancel",body,"ReportePrueba");

			this.GetData(this.parametros)
			// }

		}, (error: any) => {
			this.store.dispatch(OcultarSpinner());
			this._snackBar.open(error?.error?.error?.message || "No se pudo cancelar la factura", 'OK', { duration: 5000 })
			this.spinner = false;
			this.GetData(this.parametros)
		});
	}

	estatusCFDI = (data) => {
		this.store.dispatch(MostrarSpinner());
		this.spinner = true;
	  
		console.log('estatusCFDI', data);
	  
		const body = {
		  idFactura: data.idFactura,
		  rfcEmisor: data.rfcEmisor,
		  rfcReceptor: data.rfc,
		  motivoCancelacion: '03',
		  UUIDRelacionado: null,
		  folioUUID: data.UUID,
		};
	  
		this.coalService.postService("fac-factura-xmls/statuscancel40", body).subscribe(
		  async (res: any) => {
			try {
			  console.log('fac-factura-xmls/statuscancel40', res);
			  
			  this.store.dispatch(OcultarSpinner());
			  this.spinner = false;
	  
			  if (res && res.data && res.data.attributes) {
				const attributes = res.data.attributes;
				const body = {
				  folio_fiscal: attributes.folioFiscal || 'N/A',
				  rfcemisor: attributes.rfcEmisor || 'N/A',
				  rfcreceptor: attributes.rfcReceptor || 'N/A',
				  estcfdi: attributes.estadoCFDI || 'N/A',
				  estcancelacion: attributes.estadoCancelacion || 'N/A',
				  msgerror: '',
				  fecha: attributes.fechaEmision || 'N/A',
				  sellodigitalsat: attributes.selloDigitalSAT || 'N/A',
				  motivoCancelacion: attributes.motivoCancelacion || 'N/A',
				  UUIDRelacionado: attributes.UUIDRelacionado || 'N/A',
				};
	  
				this.store.dispatch(MostrarSpinner());
				this._snackBar.open("Descargando acuse de cancelación", 'OK', { duration: 12000 });
	  
				await this.sparroService.getReport("reportes/CallFeatureCancel", body, `Acuse de cancelación - ${attributes.rfcReceptor}`);
			  } else {
				this._snackBar.open("No se recibieron datos válidos del servicio.", 'OK', { duration: 5000 });
			  }
			} catch (error) {
			  console.error("Error procesando la respuesta:", error);
			  this._snackBar.open("Ocurrió un error procesando la respuesta del servidor.", 'OK', { duration: 5000 });
			}
		  },
		  (error: any) => {
			console.error("Error en la solicitud:", error);
			this.store.dispatch(OcultarSpinner());
			this.spinner = false;
	  
			// Mostrar error específico o genérico
			const errorMessage = error.error?.message || 'No fue posible llevar a cabo la solicitud. Por favor, intente más tarde.';
			this._snackBar.open(errorMessage, 'OK', { duration: 5000 });
	  
			// Recuperar datos si es necesario
			this.GetData(this.parametros);
		  }
		);
	};
	  

	Excepciones(pila, tipoExcepcion: number) {
		try {
			const dialogRef = this.dialog.open(ExcepcionesComponent, {
				width: '60%',
				data: {
					idTipoExcepcion: tipoExcepcion,
					idUsuario: 1,
					idOperacion: 1,
					idAplicacion: 1,
					moduloExcepcion: 'Lista-Facturas',
					mensajeExcepcion: '',
					stack: pila
				}
			});
			dialogRef.afterClosed().subscribe((result: any) => { });
		} catch (error) {
			console.error(error);
		}
	}

	openDialogEnvioMailIndividual(datafact) {
		const dialogRef = this.dialog.open(EmailDialog, {
			width: '500px',
			data: {
				emails: datafact.email,
				cc: '',
				asunto: '',
				mensaje: ''
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			//console.log('The dialog was closed');
			if (result == null) return;
			this.emails = result.emails;
			this.mensaje = result.mensaje;
			if (this.emails != null && this.emails != '') {
				//if (datafact.tipo_factura == 'Complemento de Pago') {
				/* tipoFactura:3, tipoFactura_nombre: "Complemento de Pago" */
				if (datafact.tipoFactura == 3) {
					this.SendMailFacturasIndividualFacturaComplemento(datafact, result);
				} else {
					this.SendMailFacturasIndividualFacturaNormal(datafact, result);
				}
			} else {
				console.log("No hay correos para enviar");
			}
		});
	}

	// openDialog(tipe) {
	// 	const dialogRef = this.dialog.open(EmailDialog, {
	// 		width: '500px',
	// 		data: { emails: '' },
	// 	});

	// 	dialogRef.afterClosed().subscribe(result => {
	// 		//console.log('The dialog was closed');
	// 		this.emails = result.emails;
	// 		this.mensaje = result.mensaje;
	// 		this.SendMailFacturas("sendmail");
	// 	});
	// }


}

// Expresión regular para validar un correo electrónico
const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

@Component({
	selector: 'emails-dialog',
	templateUrl: './emails-dialog.html',
	styleUrls: ['./lista-facturas.component.scss']
})
export class EmailDialog {
	formGrupo: FormGroup;
	mensaje_error: string = '';
	mostra_rerror: boolean = false;
	mensaje_error_cc: string = '';
	mostra_rerror_cc: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<EmailDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) { }

	ngOnInit(): void {
		// Inicializar el formulario con los campos y las validaciones necesarias
		this.formGrupo = new FormGroup({
			mails: new FormControl(this.data.emails || '', [Validators.required, this.emailValidator]),
			cc: new FormControl(this.data.cc || '', [this.emailValidator]),  // Campo CC opcional
			asunto: new FormControl(this.data.asunto || '', [Validators.required]),
			mensaje: new FormControl(this.data.mensaje || '', [Validators.required]),
		});
	}

	// Función personalizada para validar correos, soportando múltiples correos separados por comas
	emailValidator(control: FormControl): { [key: string]: any } | null {
		const value = control.value;

		// Si está vacío, no retorna error (campo opcional)
		if (!value) {
			return null;
		}

		// Split los correos separados por coma
		const emails = value.split(',').map(email => email.trim());

		// Validar cada correo individualmente usando la expresión regular
		for (let email of emails) {
			if (!EMAIL_PATTERN.test(email)) {
				return { emailInvalid: true };
			}
		}

		return null; // Si todos los correos son válidos, devuelve null
	}

	close(): void {
		this.dialogRef.close();
	}

	save(): void {
		this.mostra_rerror = false;
		this.mensaje_error = 'Correos inválidos:';
		this.mostra_rerror_cc = false;
		this.mensaje_error_cc = 'Correos inválidos:';

		// Validar los campos de los correos
		if (this.formGrupo.get('mails').invalid) {
			this.mostra_rerror = true;
			this.mensaje_error += ' ' + this.formGrupo.get('mails').value;
		}

		// Validar los campos de CC (solo si el campo no está vacío)
		if (this.formGrupo.get('cc').value && this.formGrupo.get('cc').invalid) {
			this.mostra_rerror_cc = true;
			this.mensaje_error_cc += ' ' + this.formGrupo.get('cc').value;
		}

		// Validar los campos de asunto
		if (this.formGrupo.get('asunto').invalid) {
			this.mostra_rerror_cc = true;
			this.mensaje_error_cc += ' Asunto requerido.';
		}

		// Validar los campos de mensaje
		if (this.formGrupo.get('mensaje').invalid) {
			this.mostra_rerror_cc = true;
			this.mensaje_error_cc += ' Mensaje requerido.';
		}

		// Si no hay errores, cerrar el diálogo y pasar los datos
		if (!this.mostra_rerror && !this.mostra_rerror_cc) {
			this.dialogRef.close(this.data);
		}
	}
}
